export default __webpack_public_path__ + "static/media/truck_full.25ce10a8.svg";